export const ExcelIconV2 = () => {
  return (
    <svg
      width="247"
      height="124"
      viewBox="0 0 247 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4_4194)">
        <path
          d="M96.1221 18.0667H134.267C143.696 18.0667 151.339 25.7104 151.339 35.1395V90.0491H96.1221V18.0667Z"
          fill="#EAEAEA"
        />
        <path d="M152.23 31.2337H137.465V16.4219" fill="#C5C5C5" />
        <path
          d="M153.339 92.2023H93.6611V15.298H139.142L153.354 30.1713V92.2023H153.339ZM95.8914 89.9567H151.109V31.0788L138.173 17.5436H95.8914V89.9567Z"
          fill="#EAEAEA"
        />
        <path
          d="M146.972 85.8034H100.029V43.9213H146.987V85.8034H146.972ZM102.26 83.5732H144.726V46.1669H102.26V83.5732Z"
          fill="#19AE57"
        />
        <path
          d="M151.297 46.6216L152.974 45.1496L159.146 52.182L157.469 53.654L151.297 46.6216Z"
          fill="#19AE57"
        />
        <path
          d="M87.9038 52.2016L94.0758 45.1692L95.753 46.6412L89.5809 53.6735L87.9038 52.2016Z"
          fill="#19AE57"
        />
        <path
          d="M87.8936 52.1823V77.5453H159.107V52.1823H87.8936ZM117.133 69.9471L114.933 66.1327L112.734 69.9471H110.719L113.918 64.8253L110.796 59.7804H112.795L114.918 63.5333L117.056 59.7804H119.04L115.917 64.8253L119.163 69.9471H117.133ZM127.376 69.9471H120.916V59.7804H122.608V68.5936H127.361V69.9471H127.376ZM135.297 69.3319C134.636 69.8395 133.775 70.0856 132.698 70.0856C131.667 70.0856 130.76 69.8087 129.991 69.255C129.222 68.7013 128.853 67.9323 128.868 66.9325L128.884 66.8864H130.514C130.514 67.5016 130.729 67.9476 131.145 68.2706C131.56 68.5782 132.083 68.7321 132.683 68.7321C133.282 68.7321 133.744 68.609 134.082 68.3475C134.421 68.1014 134.574 67.7477 134.574 67.317C134.574 66.8864 134.421 66.548 134.128 66.2711C133.821 65.9943 133.298 65.7636 132.529 65.5482C131.437 65.2406 130.591 64.8561 130.006 64.3639C129.406 63.8717 129.114 63.2257 129.114 62.4413C129.114 61.6261 129.437 60.9493 130.099 60.411C130.745 59.8881 131.591 59.6112 132.606 59.6112C133.698 59.6112 134.574 59.9034 135.236 60.4879C135.897 61.0724 136.205 61.8107 136.189 62.672L136.174 62.7181H134.544C134.544 62.1798 134.359 61.7645 134.005 61.4415C133.652 61.1185 133.175 60.9647 132.59 60.9647C132.021 60.9647 131.575 61.1031 131.268 61.3646C130.96 61.6415 130.806 61.9799 130.806 62.4105C130.806 62.795 130.975 63.118 131.314 63.3795C131.652 63.6256 132.221 63.8717 133.006 64.1024C134.067 64.3947 134.882 64.8099 135.436 65.3175C135.99 65.8251 136.266 66.4865 136.266 67.2863C136.297 68.163 135.959 68.8397 135.297 69.3319Z"
          fill="#19AE57"
        />
        <rect width="247" height="180" fill="url(#paint0_linear_4_4194)" />
        <rect
          x="8.375"
          y="98.375"
          width="50.25"
          height="19.25"
          rx="9.625"
          fill="#F3F1FC"
        />
        <rect
          x="8.375"
          y="98.375"
          width="50.25"
          height="19.25"
          rx="9.625"
          stroke="#E4DAFC"
          strokeWidth="0.75"
        />
        <path
          d="M17.2544 113V103.2H23.4424V104.348H18.6544V107.484H23.0224V108.604H18.6544V111.852H23.4424V113H17.2544ZM24.5105 113L26.9465 109.472L24.5105 105.944H26.0225L27.8705 108.688L29.7325 105.944H31.2305L28.7945 109.472L31.2305 113H29.7325L27.8705 110.242L26.0225 113H24.5105ZM35.3898 113.168C34.7084 113.168 34.1018 113.014 33.5698 112.706C33.0378 112.389 32.6178 111.955 32.3098 111.404C32.0111 110.853 31.8618 110.214 31.8618 109.486C31.8618 108.749 32.0111 108.105 32.3098 107.554C32.6178 106.994 33.0378 106.56 33.5698 106.252C34.1018 105.935 34.7084 105.776 35.3898 105.776C36.2484 105.776 36.9671 106 37.5458 106.448C38.1244 106.896 38.4931 107.503 38.6518 108.268H37.1958C37.1024 107.857 36.8878 107.54 36.5518 107.316C36.2251 107.092 35.8331 106.98 35.3758 106.98C35.0024 106.98 34.6571 107.078 34.3398 107.274C34.0224 107.461 33.7658 107.741 33.5698 108.114C33.3831 108.478 33.2898 108.931 33.2898 109.472C33.2898 109.873 33.3458 110.233 33.4578 110.55C33.5698 110.858 33.7191 111.119 33.9058 111.334C34.1018 111.549 34.3258 111.712 34.5778 111.824C34.8298 111.927 35.0958 111.978 35.3758 111.978C35.6838 111.978 35.9591 111.931 36.2018 111.838C36.4538 111.735 36.6638 111.586 36.8318 111.39C37.0091 111.194 37.1304 110.961 37.1958 110.69H38.6518C38.4931 111.437 38.1244 112.039 37.5458 112.496C36.9671 112.944 36.2484 113.168 35.3898 113.168ZM43.4819 113.168C42.8099 113.168 42.2126 113.014 41.6899 112.706C41.1672 112.398 40.7566 111.969 40.4579 111.418C40.1686 110.867 40.0239 110.228 40.0239 109.5C40.0239 108.753 40.1686 108.105 40.4579 107.554C40.7566 106.994 41.1672 106.56 41.6899 106.252C42.2126 105.935 42.8192 105.776 43.5099 105.776C44.2006 105.776 44.7932 105.93 45.2879 106.238C45.7826 106.546 46.1652 106.957 46.4359 107.47C46.7066 107.974 46.8419 108.534 46.8419 109.15C46.8419 109.243 46.8372 109.346 46.8279 109.458C46.8279 109.561 46.8232 109.677 46.8139 109.808H41.0459V108.814H45.4419C45.4139 108.226 45.2179 107.769 44.8539 107.442C44.4899 107.106 44.0372 106.938 43.4959 106.938C43.1132 106.938 42.7632 107.027 42.4459 107.204C42.1286 107.372 41.8719 107.624 41.6759 107.96C41.4892 108.287 41.3959 108.702 41.3959 109.206V109.598C41.3959 110.121 41.4892 110.564 41.6759 110.928C41.8719 111.283 42.1286 111.553 42.4459 111.74C42.7632 111.917 43.1086 112.006 43.4819 112.006C43.9299 112.006 44.2986 111.908 44.5879 111.712C44.8772 111.516 45.0919 111.25 45.2319 110.914H46.6319C46.5106 111.343 46.3052 111.731 46.0159 112.076C45.7266 112.412 45.3672 112.678 44.9379 112.874C44.5179 113.07 44.0326 113.168 43.4819 113.168ZM48.3973 113V102.92H49.7973V113H48.3973Z"
          fill="#15112D"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4_4194"
          x1="123.5"
          y1="-2.04474e-08"
          x2="123"
          y2="180"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.612635" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_4_4194">
          <rect width="247" height="124" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
